import type { QueryClient } from "@tanstack/react-query";
import { TeachersApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

export async function prefetchTeachersGet(
  queryClient: QueryClient,
  page: number = 1,
  pageSize: number = 1000,
  lastSelectedId?: number | null,
  active?: boolean,
  accessToken?: string,
) {
  if (!accessToken) {
    throw new Error("Access token is required for prefetching teachers");
  }

  const service = createAuthenticatedApi(TeachersApi, accessToken);

  await queryClient.prefetchQuery({
    queryKey: [QueryKeys.Teachers, page, pageSize, lastSelectedId, active],
    queryFn: () =>
      service.apiTeachersScrollGet({
        page,
        pageSize,
        lastSelectedId: lastSelectedId ?? undefined,
        active,
      }),
  });

  return queryClient;
}
